import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

function FormattedDocumentNode({ title = '', text = '', children = [], type = 'section', level = 1, components = null }) {
  switch (type) {
    case 'paragraph':
      return (
        <p>
          <Trans
            t={(t) => {
              return t;
            }}
            components={components}
          >
            {text}
          </Trans>
        </p>
      );
    case 'section': {
      const TitleTag = `h${level}`;
      return (
        <>
          <TitleTag>{title}</TitleTag>
          {children.map((child, index) => (
            <FormattedDocumentNode key={child.id || index} title={child.title} text={child.text} children={child.children} type={child.type} level={level + 1} components={components} /> // eslint-disable-line react/no-children-prop
          ))}
        </>
      );
    }
    default:
      return null;
  }
}

const documentNodeShape = {
  title: PropTypes.string,
  text: PropTypes.string,
};
documentNodeShape.children = PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(documentNodeShape), PropTypes.shape({ text: PropTypes.string })]));
const documentNodeType = PropTypes.oneOfType([PropTypes.string, PropTypes.shape(documentNodeShape), PropTypes.shape({ text: PropTypes.string })]);

FormattedDocumentNode.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  children: PropTypes.arrayOf(documentNodeType),
  type: PropTypes.string,
  level: PropTypes.number,
  components: PropTypes.objectOf(PropTypes.element),
};

export default FormattedDocumentNode;
